import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // Driver Score
    {
        path: '/driverscore/',
        name: 'List Driver Score',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.ds1.read) {
                    next()
                } else {
                    next({ name: 'Liveview' })
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "score" */ '@/router/views/driverscore/')
    },

    // Detail Driver Score
    {
        path: '/driverscore/detaildriverscore/:driverId',
        name: 'Detail Driver Score',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.ds1.read) {
                    next();
                } else {
                    next({ name: "List Driver Score" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "score" */ '@/router/views/driverscore/DetailDriverScore')
    },

    // Configuration
    {
        path: '/driverscore/configuration/',
        name: 'List Configuration',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.ds1['ds1-dsc1'].update) {
                    next();
                } else {
                    next({ name: "List Driver Score" });
                }
            }
        },
        component: () =>
            import('@/router/views/driverscore/configuration')
    },
]